import { ComponentsOverrides } from '@mui/material';

const styleOverrides: ComponentsOverrides['MuiToolbar'] = {
  root: {},
};

export const MuiToolbar = {
  styleOverrides,
};
